var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostpaymentInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.75 3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V14.25C3.75 15.0784 4.42157 15.75 5.25 15.75H12.75C13.5784 15.75 14.25 15.0784 14.25 14.25V5.25C14.25 4.42157 13.5784 3.75 12.75 3.75H11.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.75,
    y: 2.25,
    width: 4.5,
    height: 3,
    rx: 1.5,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M10.5 8.25H8.625C8.00368 8.25 7.5 8.75368 7.5 9.375C7.5 9.99632 8.00368 10.5 8.625 10.5H9.375C9.99632 10.5 10.5 11.0037 10.5 11.625C10.5 12.2463 9.99632 12.75 9.375 12.75H7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.6 12.75C9.6 12.4186 9.33137 12.15 9 12.15C8.66863 12.15 8.4 12.4186 8.4 12.75H9.6ZM8.4 13.5C8.4 13.8314 8.66863 14.1 9 14.1C9.33137 14.1 9.6 13.8314 9.6 13.5H8.4ZM9.6 7.5C9.6 7.16863 9.33137 6.9 9 6.9C8.66863 6.9 8.4 7.16863 8.4 7.5H9.6ZM8.4 8.25C8.4 8.58137 8.66863 8.85 9 8.85C9.33137 8.85 9.6 8.58137 9.6 8.25H8.4ZM8.4 12.75V13.5H9.6V12.75H8.4ZM8.4 7.5V8.25H9.6V7.5H8.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpaymentInvoice);
export default __webpack_public_path__ + "static/media/postpaymentInvoice.74d35fa09b1f9c4d6d38a8b2ebc6115b.svg";
export { ForwardRef as ReactComponent };